var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFancyGreenBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 171,
    viewBox: "0 0 396 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_233_132)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_233_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6 5.79086 7.79086 4 10 4H382C384.209 4 386 5.79086 386 8V155C386 157.209 384.209 159 382 159H9.99999C7.79085 159 6 157.209 6 155V8Z",
    fill: "url(#paint0_linear_233_132)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_233_132)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_233_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-239 138.312L-58.5257 -42L250.552 267.356L70.0773 447.668L-239 138.312Z",
    fill: "#A6CE43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229.101 138.316L-58.5302 -32.1005L240.652 267.351L70.0817 437.768L-229.101 138.316Z",
    stroke: "#F9F9FC",
    strokeWidth: 14
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_233_132",
    x: 0,
    y: 0,
    width: 396,
    height: 171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_233_132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_233_132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_233_132",
    x: -245,
    y: -46,
    width: 505.552,
    height: 505.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_233_132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_233_132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_233_132",
    x1: 241.288,
    y1: 67.5611,
    x2: 110.805,
    y2: 179.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#317D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BB976"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_132"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6 5.79086 7.79086 4 10 4H382C384.209 4 386 5.79086 386 8V155C386 157.209 384.209 159 382 159H9.99999C7.79085 159 6 157.209 6 155V8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_233_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 155,
    fill: "white",
    transform: "translate(6 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFancyGreenBg);
export default __webpack_public_path__ + "static/media/fancy-green-bg.4944832287c1e23d3d678b4fee2176e9.svg";
export { ForwardRef as ReactComponent };